<template>
  <div id="app">
    <Nav msg="NavSwitch"/>
    <transition><router-view /></transition>
    <Footer/>
  </div>
</template>

<script>
import Nav from './components/Nav.vue'
import Footer from "./components/Footer.vue";
export default {
  name: 'app',
  components: {
    Footer,
    Nav
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
